import { defineStore } from 'pinia';
import api from '@/js/api.js';

// Define the store
export const useFavoriteStore = defineStore('favoriteStore', {
  state: () => ({
    favorites: [],
    favoritesLoading: false,
  }),
  getters: {
    favoriteKeyReference() {
      let keyReference = {};
      this.favorites.forEach((favorite) => {
        keyReference[favorite.organizations_id] = true;
      });
      return keyReference;
    },
  },

  actions: {
    async fetchFavorites() {
      this.favoritesLoading = true;
      const response = await api.get(`/donor-accounts-favorites`);
      this.favorites = response.data;
      this.favoritesLoading = false;
    },
    async addOrgsToFavorites(orgs) {
      let response;
      try {
        response = await api.post(`/donor-accounts-favorites`, { favorites: orgs });
      } catch (error) {
        response = error;
        throw error;
      }

      this.fetchFavorites();

      return response;
    },
    async removeOrgFromFavorites(id) {
      let response;
      try {
        response = await api.delete(`/donor-accounts-favorites/${id}`);
        this.fetchFavorites(); // Only call fetchFavorites if the deletion is successful
      } catch (error) {
        response = error;
        throw error; // Ensure the error is thrown
      }

      return response;
    },
  },
});
